import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionText?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionText,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.2em] text-accent-600">
            <span className="h-[2px] w-6 bg-accent-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl font-semibold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            {description}
          </p>
        )}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-accent-600"
        >
          {actionText}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
    </div>
  );
}